export class MicrosoftFabricIntegrationConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "appId",
            "baseName": "appId",
            "type": "string",
            "format": ""
        },
        {
            "name": "connectionId",
            "baseName": "connectionId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MicrosoftFabricIntegrationConfig.attributeTypeMap;
    }
    constructor() {
    }
}
